export default __webpack_public_path__ + "static/media/addendador.35d70a89.svg";